<template>
  <portal to="modals">
    <div class="modal is-active" :class="{ 'modal-full-height': fullHeight }">
      <div class="modal-background"></div>
      <div class="modal-card" :style="{ 'max-width': width }">
        <header class="modal-card-head p-3 lg:p-5">
          <p class="modal-card-title text-lg lg:text-xl" v-text="title"></p>
          <button
            v-if="showCloseButton"
            class="delete"
            aria-label="close"
            @click="$emit('close')"
          ></button>
        </header>
        <section class="modal-card-body overscroll-contain">
          <slot></slot>
        </section>
        <footer class="modal-card-foot p-3 lg:p-5">
          <slot name="footer"></slot>
        </footer>
      </div>
    </div>
  </portal>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '640px'
    },
    fullHeight: {
      type: Boolean
    },
    showCloseButton: {
      type: Boolean,
      default: true
    }
  },
  created() {
    document.querySelector('html').classList.add('is-clipped');
  },
  beforeDestroy() {
    document.querySelector('html').classList.remove('is-clipped');
  }
};
</script>



// WEBPACK FOOTER //
// src/components/shared/Modal.vue